/* Joeba — decoreer Reisgidsen mega-menu items met vlag-iconen. v2
   Zoekt links waarvan het label overeenkomt met een bekend land en zet er een
   <img> vlag voor. Gebruikt flagcdn.com, geen emoji. */
(function(){
  'use strict';

  // Land label (lowercase, zonder diakriet) → ISO-2 flag code
  var MAP = {
    'albanie':'al','andorra':'ad','armenie':'am','azerbeidzjan':'az','belgie':'be',
    'bosnie en herzegovina':'ba','bosnie':'ba','bulgarije':'bg','cyprus':'cy',
    'denemarken':'dk','duitsland':'de','estland':'ee','finland':'fi','frankrijk':'fr',
    'georgie':'ge','griekenland':'gr','hongarije':'hu','ierland':'ie','ijsland':'is',
    'italie':'it','kosovo':'xk','kroatie':'hr','letland':'lv','liechtenstein':'li',
    'litouwen':'lt','luxemburg':'lu','malta':'mt','moldavie':'md','monaco':'mc',
    'montenegro':'me','nederland':'nl','noord-macedonie':'mk','noorwegen':'no',
    'oekraine':'ua','oostenrijk':'at','polen':'pl','portugal':'pt','roemenie':'ro',
    'rusland':'ru','san marino':'sm','servie':'rs','slovenie':'si','slowakije':'sk',
    'spanje':'es','tsjechie':'cz','turkije':'tr','vaticaanstad':'va',
    'verenigd koninkrijk':'gb','wit-rusland':'by','zweden':'se','zwitserland':'ch',
    // Azië
    'afghanistan':'af','bahrein':'bh','bangladesh':'bd','bhutan':'bt','brunei':'bn',
    'cambodja':'kh','china':'cn','filipijnen':'ph','india':'in','indonesie':'id',
    'irak':'iq','iran':'ir','israel':'il','japan':'jp','jemen':'ye','jordanie':'jo',
    'kazachstan':'kz','kirgizistan':'kg','koeweit':'kw','laos':'la','libanon':'lb',
    'maldiven':'mv','malediven':'mv','maleisie':'my','mongolie':'mn','myanmar':'mm',
    'nepal':'np','noord-korea':'kp','oman':'om','oezbekistan':'uz','pakistan':'pk',
    'palestina':'ps','qatar':'qa','saoedi-arabie':'sa','singapore':'sg',
    'sri lanka':'lk','syrie':'sy','tadzjikistan':'tj','taiwan':'tw','thailand':'th',
    'turkmenistan':'tm','verenigde arabische emiraten':'ae','vae':'ae','vietnam':'vn',
    'zuid-korea':'kr',
    // Afrika
    'algerije':'dz','angola':'ao','benin':'bj','botswana':'bw','burkina faso':'bf',
    'burundi':'bi','comoren':'km','djibouti':'dj','egypte':'eg','eritrea':'er',
    'eswatini':'sz','ethiopie':'et','gabon':'ga','gambia':'gm','ghana':'gh',
    'guinee':'gn','ivoorkust':'ci','kaapverdie':'cv','kameroen':'cm','kenia':'ke',
    'lesotho':'ls','liberia':'lr','libie':'ly','madagaskar':'mg','malawi':'mw',
    'mali':'ml','marokko':'ma','mauritanie':'mr','mauritius':'mu','mozambique':'mz',
    'namibie':'na','niger':'ne','nigeria':'ng','oeganda':'ug','rwanda':'rw',
    'senegal':'sn','seychellen':'sc','sierra leone':'sl','somalie':'so','sudan':'sd',
    'tanzania':'tz','togo':'tg','tsjaad':'td','tunesie':'tn','zambia':'zm',
    'zimbabwe':'zw','zuid-afrika':'za','zuid-sudan':'ss',
    // Noord- en Midden-Amerika
    'antigua en barbuda':'ag','aruba':'aw','bahamas':'bs','barbados':'bb',
    'belize':'bz','bonaire':'bq','canada':'ca','costa rica':'cr','cuba':'cu',
    'curacao':'cw','dominica':'dm','dominicaanse republiek':'do','el salvador':'sv',
    'grenada':'gd','guatemala':'gt','haiti':'ht','honduras':'hn','jamaica':'jm',
    'mexico':'mx','nicaragua':'ni','panama':'pa','puerto rico':'pr',
    'sint kitts en nevis':'kn','sint lucia':'lc','sint vincent':'vc',
    'trinidad en tobago':'tt','verenigde staten':'us','vs':'us',
    // Zuid-Amerika
    'argentinie':'ar','bolivia':'bo','brazilie':'br','chili':'cl','colombia':'co',
    'ecuador':'ec','guyana':'gy','paraguay':'py','peru':'pe','suriname':'sr',
    'uruguay':'uy','venezuela':'ve',
    // Oceanië
    'australie':'au','cookeilanden':'ck','fiji':'fj','frans-polynesie':'pf',
    'nieuw-caledonie':'nc','nieuw-zeeland':'nz','papoea-nieuw-guinea':'pg',
    'samoa':'ws','tonga':'to','vanuatu':'vu'
  };

  function normalize(s){
    return (s || '')
      .toLowerCase()
      .normalize('NFD').replace(/[\u0300-\u036f]/g,'') // strip diakriet
      .replace(/\s+/g,' ')
      .trim();
  }

  function decorate(root){
    var links = (root || document).querySelectorAll('a:not([data-jb-flag])');
    links.forEach(function(a){
      // sla knoppen zoals "Ontdek Europa" over
      var raw = (a.textContent || '').trim();
      if (!raw || raw.length > 40) return;
      if (/^ontdek /i.test(raw)) return;
      // sla links over die al een vlag/afbeelding bevatten (bv. hero-breadcrumb v3)
      if (a.querySelector('img')) return;
      if (a.closest && a.closest('.v2-hero__locchip, .jb-crumbs, .breadcrumb')) return;
      var key = normalize(raw);
      var cc = MAP[key];
      if (!cc) return;
      a.setAttribute('data-jb-flag','1');
      var img = document.createElement('img');
      img.src = 'https://flagcdn.com/w40/' + cc + '.png';
      img.srcset = 'https://flagcdn.com/w80/' + cc + '.png 2x';
      img.alt = '';
      img.loading = 'lazy';
      img.width = 22; img.height = 15;
      img.style.cssText = 'display:inline-block;width:22px;height:15px;margin-right:10px;vertical-align:-2px;border-radius:2px;object-fit:cover;box-shadow:0 0 0 1px rgba(0,0,0,.08);';
      a.insertBefore(img, a.firstChild);
    });
  }

  function init(){
    decorate(document);
    // Mega menu wordt vaak lazy geopend: observeer DOM mutaties
    var mo = new MutationObserver(function(muts){
      muts.forEach(function(m){
        m.addedNodes && m.addedNodes.forEach(function(n){
          if (n.nodeType === 1) decorate(n);
        });
      });
    });
    mo.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
})();